export enum ExportTypeEnum {
    SETTLEMENTS = 'settlements',
    SETTLEMENTS_ENTRIES = 'settlements_entries',
    PAYOUTS = 'payouts',
    DISPUTES = 'disputes',
    RESELLER_TRANSACTION = 'reseller_transactions',
}
